import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
interface Product {
  name: string;
  price: string;
  image: string;
  hasConfigurator?: boolean;
}
export function WacokuProductsPage() {
  const products: Product[] = [{
    name: 'Wacoku Intro Colored Belt Uniform',
    price: '$37.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FRedesign%2FWacokuIntro.jpg',
    hasConfigurator: true
  }, {
    name: 'Stephen Lambdin Special Edition Wacoku Competition Uniform',
    price: '$80.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FCustomUniform%2FStephen-Lambdin-TKD-Uniform.png',
    hasConfigurator: true
  }, {
    name: 'Wacoku WTF/WT Lightweight Uniform',
    price: '$75.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT210B.jpg800x800.jpg',
    hasConfigurator: true
  }, {
    name: 'Wacoku WTF/WT Diamond with Ventilation Uniform',
    price: '$99.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT220B.jpg',
    hasConfigurator: true
  }, {
    name: 'Wacoku WTF/WT Reversible Chest Gear',
    price: '$70.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B132W-1.jpg800x800.jpg',
    hasConfigurator: true
  }, {
    name: 'Wacoku WTF/WT Shin Guard',
    price: '$33.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B167.jpg800x800.jpg',
    hasConfigurator: true
  }, {
    name: 'Wacoku WTF/WT Forearm Guard',
    price: '$32.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B166.jpg800x800.jpg',
    hasConfigurator: true
  }, {
    name: 'Wacoku WTF/WT TKD Gloves',
    price: '$43.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B124W.jpg800x800.jpg',
    hasConfigurator: true
  }, {
    name: 'Wacoku WTF/WT Headgear',
    price: '$49.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20I201.jpg800x800.jpg',
    hasConfigurator: true
  }, {
    name: 'Wacoku Foot Protection',
    price: '$39.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWacoku-WTF-Foot-Guard.jpg',
    hasConfigurator: true
  }, {
    name: 'Wacoku Groin Cup',
    price: '$26.99',
    image: 'groin-cup',
    hasConfigurator: true
  }, {
    name: 'Wacoku Daedo Sports Bag and Backpack',
    price: '$53.00',
    image: 'sports-bag',
    hasConfigurator: false
  }, {
    name: 'Wacoku Kick Pad',
    price: '$29.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FB464%26B465.jpg800x800.jpg',
    hasConfigurator: false
  }];
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-1166">
      <Header data-id="element-1167" />

      <main className="flex-grow pt-32 pb-20" data-id="element-1168">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1169">
          {/* Wacoku Logo Section */}
          <div className="text-center mb-12" data-id="element-1170">
            <div className="inline-flex items-center justify-center mb-6" data-id="element-1171">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center" data-id="element-1172">
                <span className="text-white font-bold text-2xl" data-id="element-1173">W</span>
              </div>
              <span className="ml-3 text-4xl font-black text-gray-900" data-id="element-1174">
                Wacoku
              </span>
            </div>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-1175">
              High-quality Wacoku Taekwondo equipment including{' '}
              <span className="font-bold" data-id="element-1176">
                uniforms, protective gear, and training accessories
              </span>{' '}
              for athletes of all levels.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1177">
            {products.map((product, index) => <div key={index} className="flex items-start gap-6 p-6 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow" data-id="element-1178">
                {/* Product Image */}
                <a href="#product-gen3-efoot" className="flex-shrink-0 w-24 h-24 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden hover:opacity-80 transition-opacity" data-id="element-1179">
                  {product.image.startsWith('http') ? <img src={product.image} alt={product.name} className="w-full h-full object-contain" data-id="element-1180" /> : <span className="text-xs text-gray-400 text-center px-2" data-id="element-1181">
                      Product Image
                    </span>}
                </a>

                {/* Product Details */}
                <div className="flex-grow" data-id="element-1182">
                  <a href="#product-gen3-efoot" data-id="element-1183">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 hover:text-red-600 transition-colors" data-id="element-1184">
                      {product.name}
                    </h3>
                  </a>
                  <div className="mb-4" data-id="element-1185">
                    <span className="text-sm text-gray-600 font-semibold" data-id="element-1186">
                      Your Price
                    </span>
                    <p className="text-2xl font-black text-gray-900" data-id="element-1187">
                      {product.price}
                    </p>
                  </div>

                  <div className="flex items-center gap-3" data-id="element-1188">
                    <div className="flex items-center gap-2" data-id="element-1189">
                      <label htmlFor={`qty-${index}`} className="text-sm font-bold text-gray-700" data-id="element-1190">
                        Qty
                      </label>
                      <input type="number" id={`qty-${index}`} defaultValue="1" min="1" className="w-16 px-2 py-1 border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1191" />
                    </div>
                    <a href="#product-gen3-efoot" data-id="element-1192">
                      {product.hasConfigurator ? <Button variant="primary" className="!py-2 !px-4 text-sm" data-id="element-1193">
                          Select Options
                        </Button> : <Button variant="primary" className="!py-2 !px-4 text-sm bg-red-600 hover:bg-red-700 focus:ring-red-600" data-id="element-1194">
                          Add To Cart
                        </Button>}
                    </a>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-1195" />
    </div>;
}